import { useEffect, useState } from "react";
import { fetchGeographicUnits } from "../api/infoApi";

// Hook general para cualquier nivel: "City", "State", etc.
export function useGeographicUnits(level) {
  const [places, setPlaces] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchGeographicUnits(level)
      .then(setPlaces)
      .catch(() => setPlaces([]))
      .finally(() => setLoading(false));
  }, [level]);

  return { places, loading };
}

// Hook específico para suburbanos estructurados por ciudad
export function useSuburbGroups() {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchGeographicUnits("Suburb")
      .then((response) => {
        const raw = Array.isArray(response) ? response : response?.data;
        const filtered = (raw || []).filter(
          group =>
            group?.data_level === "Suburb" &&
            typeof group?.parent_name === "string" &&
            Array.isArray(group?.data)
        );
        setGroups(filtered);
      })
      .catch(() => setGroups([]))
      .finally(() => setLoading(false));
  }, []);

  return { suburbGroups: groups, loading };
}
